import {weaponImageName} from "../utils";

export const BASE_URL = 'https://xdloadout.pro/'
export const API_URL = BASE_URL + "api/"
export const getFeaturedLoadouts = (weapon) => {
    return fetch(`${API_URL}featured/${weaponImageName(weapon)}`, {headers: { "Sec-Fetch-Mode": "no-cors" }})
}